// @flow
import { get } from 'lodash';
import { graphqlify } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import {
  getPriceDetailFragment,
  proposalPriceQuery,
  insurancesQuery,
  getPaymentScheduleRequest,
} from 'Utils/graphql-query-helper/booking/proposal/proposalQuery';
import {
  PROPOSAL_DELETE_INSURANCES,
  PROPOSAL_UPDATE_INSURANCES,
} from 'Utils/request/requestDictionary';

function updateInsurancesMutation(
  proposalId: string,
  insuranceId: string,
  attendees: Array<LightAttendee>,
  appContext: AppContext,
): Promise<*> {
  return graphQLClient.runNoCacheQuery(
    `
    mutation {
      modifyInsurances (
      proposalId: "${proposalId}",
      insuranceId: "${insuranceId}",
      attendees:   ${graphqlify(attendees)}
     ) {
        proposal {
          id
          ${proposalPriceQuery()}
          ${insurancesQuery()}
          ${getPaymentScheduleRequest(appContext)}
        }
        errors {
          errorKey
          errorValue
          errorCode
        }
      }
    }
    ${getPriceDetailFragment(get(appContext, 'locale'))}
    `,
    appContext,
    { requestName: PROPOSAL_UPDATE_INSURANCES },
  );
}

function deleteInsurancesMutation(
  proposalId: string,
  insuranceId: string,
  appContext: AppContext,
): Promise<*> {
  return graphQLClient.runNoCacheQuery(
    `
    mutation {
      deleteInsurances (
      proposalId: "${proposalId}",
      insuranceId: "${insuranceId}",
     ) {
        proposal {
          id
          ${proposalPriceQuery()}
          ${insurancesQuery()}
          ${getPaymentScheduleRequest(appContext)}
        }
        errors {
          errorKey
          errorValue
          errorCode
        }
      }
    }
    ${getPriceDetailFragment(get(appContext, 'locale'))}
    `,
    appContext,
    { requestName: PROPOSAL_DELETE_INSURANCES },
  );
}

export { updateInsurancesMutation, deleteInsurancesMutation };
